<app-megamenu></app-megamenu>

<div class="page-content">
  <div class="container">
    <h1>{{ pageTitle }}</h1>
    <p>This page is coming soon. We're working hard to bring you the best pest control information and services.</p>
    
    <div class="placeholder-content">
      <div class="info-box">
        <h2>In the meantime...</h2>
        <p>Feel free to explore our other pages or contact us directly for any pest control needs.</p>
        
        <div class="contact-info">
          <p><strong>Phone:</strong> (555) 123-PEST</p>
          <p><strong>Email:</strong> info@completepest.com</p>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>